document.addEventListener('DOMContentLoaded', function () {
    const buttons = document.querySelectorAll('.quick-add__submit');
    buttons.forEach((button) => {
      button.addEventListener('click', function() {
        const id = button.parentNode.dataset.modal;
  
        const section = document.querySelector(id);
        if (!section) return;
  
        // Verifica a cada 500ms se o modal está aberto
        const checkModal = setInterval(() => {
          if (document.querySelector(id).hasAttribute('open')) {
            if(section.querySelector('.flavours')) {
              newVariantPicker(section);
            }
            clearInterval(checkModal); // Para a verificação após executar a função
          }
        }, 500);
      })
    });
    
    function newVariantPicker(section) {
      // Inputs de quantidade de cada Sabor
      const flavour_qty_inputs = section.querySelectorAll('.flavours__wrapper .quantity__input');
      // Botão de comprar
      const buy_button = section.querySelectorAll('.product-form__submit')[0];
      // Botão de aumentar quantidade de cada Sabor
      const flavour_qty_plus = section.querySelectorAll('.quantity__plus');
      // Botão de diminuir quantidade de cada Sabor
      const flavour_qty_minus = section.querySelectorAll('.quantity__minus');
      // Inputs para enviar quantidades de variantes para carrinho
      const variants_quantity = section.querySelectorAll('.variant-quantity');
      // Container de cada input de sabor
      const flavour_wrapper = section.querySelectorAll('.flavour-input_wrapper');

      // Sem sabores ou sem botão de compra não há nada para calcular.
      if (!flavour_qty_inputs.length || !buy_button) return;

      // Preços a serem substituídos
      const old_price = section.querySelector('#regular-price');
      const old_sale_price = section.querySelector('#sale-price');
      const old_pix_price = section.querySelector('#pix-price');
      const pix_discount = old_pix_price ? old_pix_price.dataset.pixDiscount : 1;

      // V1: a faixa vem do total de caixas montado, não de um pacote escolhido.
      // Fonte dos números: data-tiers em pdp-tiers.liquid, alimentado pelos metafields.
      const tiersEl = section.querySelector('[data-pdp-tiers]');
      let TIERS = [];
      let UNIDADES = 1;
      let NOME_UNIDADE = 'unidade';
      if (tiersEl) {
        try { TIERS = JSON.parse(tiersEl.dataset.tiers || '[]'); } catch (e) { TIERS = []; }
        TIERS.sort((a, b) => a.caixas - b.caixas);
        UNIDADES = parseInt(tiersEl.dataset.unidades) || 1;
        NOME_UNIDADE = tiersEl.dataset.nomeUnidade || 'unidade';

        // Percentuais exibidos na assinatura, configurados no editor de temas.
        // A lista vem da menor faixa para a maior, casada depois da ordenação.
        // Isso altera apenas o rótulo. O preço continua saindo de tier.desconto.
        const offAss = (tiersEl.dataset.offAssinatura || '')
          .split(',')
          .map(v => parseInt(v.trim()))
          .filter(v => !isNaN(v));
        if (offAss.length === TIERS.length) {
          TIERS.forEach((t, i) => { t.offAssinatura = offAss[i]; });
        }
      }

      // Preço de referência do modo atual. applyMode mantém esses data attributes.
      function basePrice() {
        return parseInt(flavour_qty_inputs[0].dataset.price) || 0;
      }
      function comparePrice() {
        const c = parseInt(flavour_qty_inputs[0].dataset.comparePrice);
        return c && c > basePrice() ? c : basePrice();
      }
      function freteSempre() {
        return section.querySelector('.purchase-mode-toggle__btn.active')?.dataset.mode === 'assinatura';
      }
      function tierIndex(total) {
        let idx = -1;
        TIERS.forEach((t, i) => { if (total >= t.caixas) idx = i; });
        return idx;
      }
      function totalCaixas() {
        let t = 0;
        flavour_qty_inputs.forEach((i) => { t += parseInt(i.value) || 0; });
        return t;
      }

      // Monta os três trilhos da barra. Chamado no load e a cada troca de modo,
      // porque os preços por unidade mudam junto com o preço base.
      function renderTiers() {
        if (!tiersEl || !TIERS.length) return;
        const top = tiersEl.querySelector('[data-tiers-top]');
        const mk = tiersEl.querySelector('[data-tiers-markers]');
        const bot = tiersEl.querySelector('[data-tiers-bottom]');
        const base = basePrice();
        const cols = `repeat(${TIERS.length}, 1fr)`;
        [top, mk, bot].forEach((el) => { el.innerHTML = ''; el.style.gridTemplateColumns = cols; });

        TIERS.forEach((t, i) => {
          const cheio = base * t.caixas;
          const comDesconto = Math.round(cheio * (100 - t.desconto) / 100);
          const porUnidade = comDesconto / (t.caixas * UNIDADES);
          const ultima = i === TIERS.length - 1;

          const c1 = document.createElement('div');
          c1.className = 'pdp-tier';
          c1.innerHTML = `<span class="pdp-tier__price">${formatMoney(porUnidade / 100)}<small>/${NOME_UNIDADE}</small></span>
            <span class="pdp-tier__qty">${t.caixas * UNIDADES} ${NOME_UNIDADE}s${ultima ? ' ou mais' : ''}</span>`;
          top.appendChild(c1);

          const c2 = document.createElement('div');
          c2.className = 'pdp-tier';
          c2.innerHTML = '<span class="pdp-tier__marker"><i></i></span>';
          mk.appendChild(c2);

          const assinatura = freteSempre();
          const beneficio = assinatura ? 'Frete grátis' : (t.tag || '');
          // Rótulo apenas. Na assinatura usa a lista configurada, se existir.
          const off = assinatura && t.offAssinatura != null ? t.offAssinatura : t.desconto;
          const c3 = document.createElement('div');
          c3.className = 'pdp-tier';
          c3.innerHTML = `<span class="pdp-tier__off">${off ? off + '% OFF' : ''}</span>
            <span class="pdp-tier__benefit">${beneficio}</span>`;
          bot.appendChild(c3);
        });
      }

      // Acende as faixas já conquistadas e move o preenchimento.
      function paintTiers(total) {
        if (!tiersEl || !TIERS.length) return;
        const idx = tierIndex(total);
        ['[data-tiers-top]', '[data-tiers-markers]', '[data-tiers-bottom]'].forEach((sel) => {
          const filhos = tiersEl.querySelector(sel).children;
          for (let k = 0; k < filhos.length; k++) {
            filhos[k].classList.toggle('is-active', k <= idx);
            filhos[k].classList.toggle('is-current', k === idx);
          }
        });
        const fill = tiersEl.querySelector('[data-tiers-fill]');
        fill.style.width = idx <= 0 ? '0%' : (idx / (TIERS.length - 1) * 100) + '%';
      }
  
      function formatMoney(value) {
        return value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace(/\u00A0/g, '');
      }
  
      // Selo de economia ao lado do título da assinatura.
      // Mostra quanto a assinatura economiza contra a compra única, na quantidade
      // montada. Sem nada montado, usa uma caixa como referência, que é o mesmo
      // valor que o Liquid já renderizou no servidor.
      function atualizarSelo(total, desconto) {
        const selo = section.querySelector('[data-pm-economia]');
        if (!selo) return;

        const precoUnica = parseInt(flavour_qty_inputs[0].dataset.priceUnica);
        const precoAssinatura = parseInt(flavour_qty_inputs[0].dataset.priceAssinatura);
        // Antes do fetch os dois preços ainda não existem. Mantém o valor do servidor.
        if (!precoUnica || !precoAssinatura || precoUnica <= precoAssinatura) return;

        const caixas = total > 0 ? total : 1;
        const economia = Math.round((precoUnica - precoAssinatura) * caixas * (100 - desconto) / 100);
        selo.textContent = `${selo.dataset.rotulo} ${formatMoney(economia / 100)}`;
      }

      function pricesAndButton() {
        const total = totalCaixas();
        const idx = tierIndex(total);
        const desconto = idx >= 0 ? TIERS[idx].desconto : 0;

        const cheio = basePrice() * total;
        const comDesconto = Math.round(cheio * (100 - desconto) / 100);
        // Âncora: o maior entre preço cheio de loja e o total sem desconto de faixa.
        // Na assinatura isso traz o compare_at_price, que é o preço de compra única.
        const ancora = Math.max(cheio, comparePrice() * total);

        if (ancora > comDesconto) {
          old_sale_price.textContent = formatMoney(ancora / 100);
          old_sale_price.parentElement.classList.remove('visually-hidden');
        } else {
          old_sale_price.parentElement.classList.add('visually-hidden');
          old_sale_price.textContent = '';
        }

        old_price.textContent = formatMoney(comDesconto / 100);
        if (old_pix_price) {
          old_pix_price.textContent = formatMoney(comDesconto * pix_discount / 100);
        }

        // V1: libera com qualquer caixa montada. Não existe mais soma exata.
        buy_button.disabled = total === 0;

        paintTiers(total);
        atualizarSelo(total, desconto);
        changeDisabled();
        changeMinusDisabled();
      }
      
      // Botão Adicionar de cada sabor. Coloca 1 e delega para o listener de change,
      // que já cuida de not-chosen, do input do carrinho e do recálculo.
      section.querySelectorAll('[data-flavour-add]').forEach((btn) => {
        btn.addEventListener('click', function () {
          const i = parseInt(this.dataset.flavourAdd);
          const input = flavour_qty_inputs[i];
          if (!input || this.disabled) return;
          input.value = 1;
          input.dispatchEvent(new Event('change'));
        });
      });

      // Função para reforçar mínimo e máximo de quantidade
      function enforceMinMax(el) {
        if (el.value != "") {
          if (parseInt(el.value) < parseInt(el.min)) {
            el.value = el.min;
          }
          if (parseInt(el.value) > parseInt(el.max)) {
            el.value = el.max;
          }
        }
      }
  
      flavour_qty_inputs.forEach((item, i) => {
        item.addEventListener('change', function() {
          enforceMinMax(this);
  
          flavour_wrapper[i].classList.toggle('not-chosen', this.value == 0);
          variants_quantity[i].value = this.value;

          pricesAndButton();
        })
      })

      // V1: o mais só travava quando o pacote enchia. Agora só o estoque limita.
      function changeDisabled() {
        flavour_qty_plus.forEach((item, i) => {
          const input = flavour_qty_inputs[i];
          const indisponivel = flavour_wrapper[i].classList.contains('unavailable');
          const noTeto = parseInt(input.value) >= parseInt(input.max || input.dataset.max || 999);
          const travado = indisponivel || noTeto;
          item.disabled = travado;
          item.classList.toggle('disabled', travado);
        });
      }

      function changeMinusDisabled() {
        flavour_qty_minus.forEach((item, i) => {
          if(flavour_qty_inputs[i].value <= 0) {
            item.disabled = true;
            item.classList.add('disabled');
          } else {
            item.disabled = false;
            item.classList.remove('disabled');
          }
        });
      }
      
      renderTiers();
      changeDisabled();
      /*
      // Setando variantes pré-selecionadas
      let j = 0;
      let count = 0;

      while (count < quantities[0]) {
        // Se o wrapper não tiver a classe 'unavailable', clica e incrementa a contagem
        if (!flavour_wrapper[j].classList.contains('unavailable')) {
          flavour_qty_plus[j].click();
          count++; // Aumenta a contagem de cliques bem-sucedidos
        }

        // Avança para o próximo wrapper
        j++;

        // Se chegou ao final da lista, volta para o início
        if (j >= flavour_wrapper.length) {
          j = 0;
        }
      }
      */
      pricesAndButton();

      initModeToggle(section, pricesAndButton, formatMoney, renderTiers);
    }

    function initModeToggle(section, pricesAndButton, formatMoney, renderTiers) {
      const toggle = section.querySelector('.purchase-mode-toggle');
      if (!toggle) return;

      const wrapper = section.querySelector('.flavours__wrapper');
      const handleUnica = wrapper.dataset.handle;
      const handleAssinatura = toggle.dataset.handleAssinatura;
      const skusUnica = toggle.dataset.skusUnica.split(',');
      const skusAssinatura = toggle.dataset.skusAssinatura.split(',');

      async function fetchBySku(handle) {
        const res = await fetch(`/products/${handle}.js`);
        if (!res.ok) throw new Error(`Produto não encontrado: ${handle}`);
        const data = await res.json();
        const map = {};
        data.variants.forEach(v => {
          map[v.sku] = {
            id: v.id,
            price: v.price,
            compare_at_price: v.compare_at_price,
            available: v.available,
            inventory_quantity: v.inventory_quantity
          };
        });
        return map;
      }

      // Inicia o fetch imediatamente para ter os dados prontos quando o usuário clicar
      const dataPromise = Promise.all([
        fetchBySku(handleUnica),
        fetchBySku(handleAssinatura)
      ]).catch(e => {
        console.error('[Purchase Toggle] Erro ao buscar dados dos produtos:', e);
        return null;
      });

      function applyMode(mode, variantsMap) {
        const { skus, variants, handle } = variantsMap[mode];
        const flavourInputs = section.querySelectorAll('.flavours__wrapper .quantity__input');
        const quantityInputEls = section.querySelectorAll('.flavours__wrapper quantity-input');
        const flavourWrappers = section.querySelectorAll('.flavour-input_wrapper');
        const variantQtyInputs = section.querySelectorAll('.variant-quantity');

        // V1: preserva o que a pessoa já montou ao trocar de modo.
        const prevQtys = [...flavourInputs].map(i => parseInt(i.value) || 0);

        flavourInputs.forEach((input, i) => {
          const sku = skus[i];
          const variant = variants[sku];
          if (!variant) return;

          quantityInputEls[i].dataset.url = `/products/${handle}?variant=${variant.id}`;

          input.dataset.price = variant.price;
          input.dataset.comparePrice = variant.compare_at_price || variant.price;

          // Guarda os dois preços para o selo de economia poder ser calculado
          // em qualquer modo, inclusive quando a pessoa está em compra única.
          const vUnica = variantsMap.unica.variants[variantsMap.unica.skus[i]];
          const vAssinatura = variantsMap.assinatura.variants[variantsMap.assinatura.skus[i]];
          if (vUnica) input.dataset.priceUnica = vUnica.price;
          if (vAssinatura) input.dataset.priceAssinatura = vAssinatura.price;
          const maxQty = variant.available
            ? (variant.inventory_quantity > 0 ? variant.inventory_quantity : 999)
            : 0;
          input.dataset.max = maxQty;
          input.max = maxQty;
          const qty = Math.min(prevQtys[i] || 0, maxQty);
          input.value = qty;
          input.dataset.cartQuantity = 0;

          const idInput = section.querySelector(`.product-variant-id-${i}`);
          if (idInput) {
            idInput.value = variant.id;
            idInput.disabled = !variant.available;
          }

          if (variantQtyInputs[i]) {
            variantQtyInputs[i].value = qty;
            variantQtyInputs[i].disabled = !variant.available;
          }

          if (!variant.available || maxQty === 0) {
            flavourWrappers[i].classList.add('unavailable');
          } else {
            flavourWrappers[i].classList.remove('unavailable');
          }
          flavourWrappers[i].classList.toggle('not-chosen', qty === 0);
        });

        // V1: a barra de faixas é redesenhada com o preço base do modo novo.
        // O benefício de frete e os rótulos saem de renderTiers, não mais de labels.
        if (renderTiers) renderTiers();

        const url = new URL(window.location.href);
        url.searchParams.set('modo', mode);
        history.pushState({}, '', url);

        pricesAndButton();
      }

      const btns = toggle.querySelectorAll('.purchase-mode-toggle__btn');

      // Registra os cliques imediatamente — sem depender do fetch
      btns.forEach(btn => {
        btn.addEventListener('click', async () => {
          if (btn.classList.contains('active')) return;
          const mode = btn.dataset.mode;
          btns.forEach(b => b.classList.toggle('active', b === btn));

          const result = await dataPromise;
          if (!result) return;
          const [unicaVariants, assinaturaVariants] = result;
          applyMode(mode, {
            unica: { skus: skusUnica, variants: unicaVariants, handle: handleUnica },
            assinatura: { skus: skusAssinatura, variants: assinaturaVariants, handle: handleAssinatura }
          });
        });
      });

      // Aplica modo inicial vindo da URL
      const initialMode = new URLSearchParams(window.location.search).get('modo') || 'assinatura';
      if (initialMode === 'assinatura') {
        dataPromise.then(result => {
          if (!result) return;
          const [unicaVariants, assinaturaVariants] = result;
          btns.forEach(b => b.classList.toggle('active', b.dataset.mode === 'assinatura'));
          applyMode('assinatura', {
            unica: { skus: skusUnica, variants: unicaVariants, handle: handleUnica },
            assinatura: { skus: skusAssinatura, variants: assinaturaVariants, handle: handleAssinatura }
          });
        });
      }
    }

    const product_infos = document.querySelectorAll('product-info:has(.variants-wrapper)');
    product_infos.forEach((section) => {
      newVariantPicker(section);
    })

    // Toggle Assinatura / Compra Única para o picker padrão (variant-selects)
    // Usa event delegation + re-query do DOM para sobreviver a re-renders do tema
    function initStandardModeToggle() {
      const toggle = document.querySelector('[data-pm-toggle-standard]');
      if (!toggle) return;
      if (document._pmStandardToggleReady) return;
      document._pmStandardToggleReady = true;

      const handleAssinatura = toggle.dataset.handleAssinatura;
      const skusUnica      = toggle.dataset.skusUnica.split(',');
      const skusAssinatura = toggle.dataset.skusAssinatura.split(',');
      const dosesCount     = [15, 60];

      // Fetch assinatura — único fetch necessário
      const dataPromise = fetch(`/products/${handleAssinatura}.js`)
        .then(r => { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(data => {
          const map = {};
          data.variants.forEach(v => {
            map[v.sku] = { id: v.id, price: v.price, compare_at_price: v.compare_at_price };
          });
          return map;
        })
        .catch(e => { console.error('[PM Toggle Standard]', e); return null; });

      // Taxa pix calculada uma vez no load (ratio estável para o produto)
      let pixRate = null;
      {
        const vs  = document.querySelector('variant-selects[data-section]');
        const sec = vs ? document.getElementById(`shopify-section-${vs.dataset.section}`) : null;
        const sp  = sec?.querySelector('.price-item--sale')?.textContent || '';
        const pp  = sec?.querySelector('.pix-price')?.textContent || '';
        const s = parseFloat(sp.replace(/[^\d,]/g, '').replace(',', '.'));
        const p = parseFloat(pp.replace(/[^\d,]/g, '').replace(',', '.'));
        if (s && p) pixRate = p / s;
      }

      // Snapshot das doses unica (capturado sempre antes de sobrescrever)
      let origDoses = null;

      // Modo armazenado em variável JS — não depende da URL
      // (o tema usa history.replaceState('?variant=xxx') que apagaria ?modo= da URL)
      document._pmCurrentMode = document._pmCurrentMode ||
        new URLSearchParams(window.location.search).get('modo') || 'assinatura';

      // Cache síncrono das variantes — necessário para o interceptor de submit
      let cachedAssVariants = null;
      dataPromise.then(v => { cachedAssVariants = v; });

      // Intercepta o submit do formulário na fase de captura (antes do handler do tema)
      // Garante o ID correto independente de qualquer re-render AJAX
      document.addEventListener('submit', (e) => {
        const variantInput = e.target?.querySelector('input[name="id"]');
        if (!variantInput) return;
        if (getCurrentMode() !== 'assinatura') return;
        if (!cachedAssVariants) return;
        const unicaSku = getVariantData().sku;
        const idx      = skusUnica.indexOf(unicaSku);
        const assSku   = idx !== -1 ? skusAssinatura[idx] : null;
        const assV     = assSku ? cachedAssVariants[assSku] : null;
        if (assV?.id) variantInput.value = assV.id;
      }, true);

      function money(cents) {
        return (cents / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }
      function getCurrentMode() {
        return document._pmCurrentMode;
      }
      function setCurrentMode(mode) {
        document._pmCurrentMode = mode;
        const url = new URL(window.location.href);
        url.searchParams.set('modo', mode);
        history.pushState({}, '', url);
      }

      // Re-queries frescos a cada chamada (sobrevivem a re-renders)
      function getSec() {
        const vs = document.querySelector('variant-selects[data-section]');
        return vs ? document.getElementById(`shopify-section-${vs.dataset.section}`) : null;
      }
      function getVariantIdInput() {
        const vs = document.querySelector('variant-selects[data-section]');
        if (!vs) return null;
        return document.querySelector(`#product-form-${vs.dataset.section} input[name="id"]`);
      }
      function getVariantData() {
        const vs = document.querySelector('variant-selects[data-section]');
        try { return JSON.parse(vs?.querySelector('script[data-selected-variant]')?.textContent || '{}'); }
        catch(e) { return {}; }
      }
      function setButtons(mode) {
        document.querySelectorAll('[data-pm-toggle-standard] .purchase-mode-toggle__btn').forEach(b => {
          b.classList.toggle('active', b.dataset.mode === mode);
        });
      }

      // Selo de economia do caminho padrão. Premium e Cerimonial vendem por dose,
      // então a economia é a diferença entre a variante escolhida e a variante
      // equivalente da assinatura. Vale nos dois modos.
      function atualizarSeloStandard() {
        const selo = document.querySelector('[data-pm-toggle-standard] [data-pm-economia]');
        if (!selo || !cachedAssVariants) return;
        const v = getVariantData();
        const idx = skusUnica.indexOf(v.sku);
        const assSku = idx !== -1 ? skusAssinatura[idx] : null;
        const assV = assSku ? cachedAssVariants[assSku] : null;
        if (!v.price || !assV || assV.price >= v.price) return;
        escrever(selo, `${selo.dataset.rotulo} R$${money(v.price - assV.price)}`);
      }

      // Escreve só quando o valor muda de fato.
      //
      // Isso não é economia de ciclos, é o que impede laço infinito. O
      // MutationObserver que corrige o preço observa o mesmo bloco que a correção
      // escreve. Atribuir textContent troca o nó de texto e conta como mutação
      // mesmo quando a string é idêntica, então uma escrita incondicional
      // realimentaria o observer para sempre.
      function escrever(el, valor) {
        if (el && el.textContent !== valor) el.textContent = valor;
      }

      function writePrice(v) {
        const sec = getSec();
        if (!v?.price || !sec) return;
        const ps = `R$${money(v.price)}`;
        escrever(sec.querySelector('.price-item--sale'), ps);
        escrever(sec.querySelector('.price__regular .price-item--regular'), ps);
        if (v.compare_at_price) {
          escrever(sec.querySelector('.price__sale .price-item--regular'), `R$${money(v.compare_at_price)}`);
        }
        if (pixRate) {
          escrever(sec.querySelector('.pix-price'), `R$${money(Math.round(v.price * pixRate))} no pix`);
        }
      }

      function enterAssinatura(assVariants) {
        const sec  = getSec();
        const input = getVariantIdInput();
        const unicaSku = getVariantData().sku;
        const idx    = skusUnica.indexOf(unicaSku);
        const assSku = idx !== -1 ? skusAssinatura[idx] : null;
        const assV   = assSku ? assVariants[assSku] : null;

        if (input && assV?.id) input.value = assV.id;
        writePrice(assV);

        // Doses e tag de frete usam as mesmas funções da reaplicação, para não
        // existirem duas implementações do mesmo desenho.
        escreverDoses(assVariants);
        marcarFreteGratis();

        setButtons('assinatura');
        setCurrentMode('assinatura');
        atualizarSeloStandard();
      }

      function enterUnica() {
        const sec   = getSec();
        const input = getVariantIdInput();
        const v     = getVariantData();

        if (input && v.id) input.value = v.id;
        writePrice(v);

        const doseEls = [...(sec?.querySelectorAll('.dose-price') || [])];
        if (origDoses) doseEls.forEach((el, i) => { if (origDoses[i]) el.innerHTML = origDoses[i]; });

        sec?.querySelectorAll('.product-form__input--pill label').forEach(label => {
          label.querySelectorAll('.tag-frete-js').forEach(t => t.remove());
          label.querySelector('.tag')?.style.removeProperty('display');
        });

        setButtons('unica');
        setCurrentMode('unica');
        atualizarSeloStandard();
      }

      // ----------------------------------------------------------------
      // Reaplicação depois do re-render do tema.
      //
      // Antes: o observer esperava 30ms, dava await no fetch e ainda repetia
      // tudo 300ms depois. O tema pintava o preço de compra única, ficava
      // visível por volta de 150ms, e só então era corrigido. Era isso que
      // parecia recarregar a página.
      //
      // Agora, no mesmo espírito do Latte: os dados já estão em memória, então
      // a correção é síncrona dentro do próprio callback do observer, antes do
      // navegador pintar o frame. Nada de timer, nada de segunda passada.
      // ----------------------------------------------------------------

      let reaplicando = false;

      function reaplicarAssinatura() {
        if (reaplicando || getCurrentMode() !== 'assinatura') return;
        if (!cachedAssVariants) return;
        reaplicando = true;
        try {
          const unicaSku = getVariantData().sku;
          const idx = skusUnica.indexOf(unicaSku);
          const assSku = idx !== -1 ? skusAssinatura[idx] : null;
          const assV = assSku ? cachedAssVariants[assSku] : null;

          const input = getVariantIdInput();
          if (input && assV?.id) input.value = assV.id;
          writePrice(assV);
          escreverDoses(cachedAssVariants);
          marcarFreteGratis();
        } finally {
          reaplicando = false;
        }
      }

      function escreverDoses(assVariants) {
        const sec = getSec();
        const doseEls = [...(sec?.querySelectorAll('.dose-price') || [])];
        if (origDoses === null && doseEls.length) {
          origDoses = doseEls.map(el => el.innerHTML);
        }
        doseEls.forEach((el, i) => {
          const v = assVariants[skusAssinatura[i]];
          if (!v) return;
          const dp = (v.price / dosesCount[i] / 100)
            .toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          const novo = `R$${dp}<small>/dose</small>`;
          if (el.innerHTML !== novo) el.innerHTML = novo;
        });
      }

      function marcarFreteGratis() {
        getSec()?.querySelectorAll('.product-form__input--pill label').forEach(label => {
          label.querySelector('.tag:not(.tag-frete-js)')?.style.setProperty('display', 'none');
          if (!label.querySelector('.tag-frete-js')) {
            const tag = document.createElement('span');
            tag.className = 'tag tag-frete-js';
            tag.textContent = 'Frete grátis';
            label.prepend(tag);
          }
        });
      }

      // Observa o bloco de preço e as labels. Correção síncrona, sem debounce.
      {
        const vs = document.querySelector('variant-selects[data-section]');
        const priceEl = vs ? document.getElementById(`price-${vs.dataset.section}`) : null;
        const aoRerender = () => { reaplicarAssinatura(); atualizarSeloStandard(); };

        if (priceEl) {
          new MutationObserver(aoRerender).observe(priceEl, { childList: true, subtree: true });
        }
        if (vs) {
          new MutationObserver(aoRerender).observe(vs, { childList: true, subtree: true });
        }
      }

      // O tema dispara product-info:loaded ao terminar o re-render da seção.
      // O antigo listener de 'variant:change' nunca rodava, esse evento não
      // existe neste tema, e era por isso que o selo ficava parado.
      document.addEventListener('product-info:loaded', () => {
        reaplicarAssinatura();
        atualizarSeloStandard();
      });

      // Clique no toggle. Uma passada só.
      document.addEventListener('click', async e => {
        const btn = e.target.closest('[data-pm-toggle-standard] .purchase-mode-toggle__btn');
        if (!btn) return;
        const target = btn.dataset.mode;
        if (target === getCurrentMode()) return;

        if (target === 'assinatura') {
          const assVariants = await dataPromise;
          if (!assVariants) return;
          enterAssinatura(assVariants);
        } else {
          enterUnica();
        }
      });

      // Modo inicial da URL
      if (document._pmCurrentMode === 'assinatura') {
        dataPromise.then(assVariants => {
          if (!assVariants) return;
          enterAssinatura(assVariants);
        });
      }

      // Primeiro desenho do selo, assim que os preços de assinatura chegarem
      dataPromise.then(() => atualizarSeloStandard());
    }

    initStandardModeToggle();
  })